import { notification } from "antd";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  fetchWeldParametersFailure,
  fetchWeldParametersSuccess,
} from "./action.js";
import {
  FETCH_WELD_PARAMETERS_REQUEST,
  PUT_RENAME_LOADER_START,
  PUT_RENAME_LOADER_STOP,
  UPDATE_RENAME_PASSES,
  WELD_PARAMETERS_LOADER_START,
  WELD_PARAMETERS_LOADER_STOP,
} from "./types.js";
import { ADMIN_URL } from "../../config.js";
import fetch from "../../services/fetch.js";

function* fetchWeldParametersSaga(action) {
  try {
    yield put({ type: WELD_PARAMETERS_LOADER_START });

    const { project_id, job_number, welding_system, pipe_name } =
      action.payload;

    // Build query parameters
    const params = new URLSearchParams();
    if (project_id) params.append("project_id", project_id);
    if (job_number) params.append("job_number", job_number);
    if (welding_system) params.append("welding_system", welding_system);
    if (pipe_name) params.append("pipe_name", pipe_name);

    const url = `${ADMIN_URL}/v1/limits/get-weld-parameters-json?${params.toString()}`;

    const res = yield call(fetch, url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (res.status === 403) {
      yield put({ type: WELD_PARAMETERS_LOADER_STOP });
      throw new Error("Unauthorized");
    }

    if (res.status === 410) {
      return;
    }

    const response = yield res.json();

    if (res.ok) {
      const responseData = response.data || response;
      yield put(fetchWeldParametersSuccess(responseData));

      if (typeof action.payload.cb === "function") {
        action.payload.cb(responseData);
      }
    } else {
      const errorMessage =
        response.message || "Failed to fetch weld parameters";
      yield put(fetchWeldParametersFailure(errorMessage));

      notification.error({
        message: errorMessage,
        duration: 4,
      });

      if (typeof action.payload.error === "function") {
        action.payload.error(errorMessage);
      }
    }
  } catch (error) {
    console.error("Error in fetchWeldParametersSaga:", error);
    const errorMessage = error.message || "Network error occurred";
    yield put(fetchWeldParametersFailure(errorMessage));

    notification.error({
      message: errorMessage,
      duration: 4,
    });

    if (typeof action.payload.error === "function") {
      action.payload.error(errorMessage);
    }
  } finally {
    yield put({ type: WELD_PARAMETERS_LOADER_STOP });
  }
}

function* renamePassNamesSaga(action) {
  try {
    yield put({ type: PUT_RENAME_LOADER_START });

    const url = `${ADMIN_URL}/v1/limits/rename-pass`;

    const res = yield call(fetch, url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(action.payload),
    });

    if (res.status === 403) {
      yield put({ type: PUT_RENAME_LOADER_STOP });
      throw new Error("Unauthorized");
    }

    const response = yield res.json();

    if (res.ok) {
      const responseData = response;
      if (responseData) {
        notification.success({
          message: response?.message || "Passes renamed Successfully",
          duration: 4,
        });
      }
      action.payload.cb();
    } else {
      const errorMessage =
        response.message || "Failed to fetch weld parameters";

      notification.error({
        message: errorMessage,
        duration: 4,
      });
      action.payload.cb();
    }
  } catch (error) {
    console.error("Error in renamePassSaga:", error);
    const errorMessage = error.message || "Network error occurred";

    notification.error({
      message: errorMessage,
      duration: 4,
    });
    action.payload.cb();
  } finally {
    yield put({ type: PUT_RENAME_LOADER_STOP });
    action.payload.cb();
  }
}

export default function* data360LiveWeldParameterSaga() {
  yield all([
    takeLatest(FETCH_WELD_PARAMETERS_REQUEST, fetchWeldParametersSaga),
    takeLatest(UPDATE_RENAME_PASSES, renamePassNamesSaga),
  ]);
}
